<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<p><a id="page_normal--num_3--seq_3"> </a></p><a id="page_normal--num_3--seq_3">
<div class="title-block-book">
<h1>THE RAKE’S REBELLIOUS LADY </h1>
<p class="title-author">Anne Herries </p>
<div class="imprint">
<p class="title-publisher">
<img alt="" src="new_mab02_logo.jpg" title=""/>
</p>
</div>
</div>
</a></div><a id="page_normal--num_3--seq_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781408901175_booktitlepage.vue?dd710ff6